export default __webpack_public_path__ + "static/media/66.e2b74ab5.png";